import './Header.scss';

import Button from '../../ui/Button';

const Header = ({ image, title, description, buttons, style }) => {
    const styles = {
        background: `center / cover url(${image})`,
        backgroundBlendMode: 'multiply',
        ...style,
    };

    return (
        <header className="Header" style={styles}>
            <div className="container">
                <h1 className="heading heading--large heading--white">
                    {title}
                </h1>

                {description && (
                    <p className="Header__description text text--white mt2">
                        {description}
                    </p>
                )}

                {buttons &&
                    buttons.map(button => {
                        return (
                            <Button
                                label={button.label}
                                link={button.link}
                                type={button.type}
                                size={button.size}
                                target={button.target}
                            />
                        );
                    })}
            </div>
        </header>
    );
};

export default Header;
